import { sendAmplitudeData, setAmplitudeUserProperties } from './amplitude';

const logEvent = async (
  token: string,
  type: string,
  properties: any,
  text?: string,
  userProperties?: any,
) => {
  logToAmplitude(type, properties, text, userProperties);
};

const logToAmplitude = (
  type: string,
  properties: any,
  text: string,
  userProperties?: any,
) => {
  setAmplitudeUserProperties(userProperties);
  sendAmplitudeData(`[Web ${type}] ${text}`, properties);
};

export const analyticsApi = {
  logEvent
};